<app-item-content [instructionItemContentTemplate]="itemContentBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentBoxes let-index="index" let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps) {
		@if (instruction.area) { <app-instruction-box>{{ instruction.area }}</app-instruction-box> }
		@if (instruction.skincareLevel !== null) { <app-instruction-box>{{ skincareLevel[index] }}</app-instruction-box> }
	}
</ng-template>